export interface Testimonial {
  quote: string;
  name: string;
  designation: string;
  src: string;
  linkedin?: string;
  color?: string;
}

export const testimonials: Testimonial[] = [
  {
    quote: "I have been overseeing Aditya's progress as the mentor for his final year project and as the head of his department. His decisions were guided by a coherent and logical rationale. During project reviews, he showcased a strong command of technical skills and articulated them with remarkable confidence. His presentations were clear and concise.",
    name: "Dr. Shailendra Aswale",
    designation: "Professor, HOD and Dean of Academics - Padre Conceição College of Engineering",
    src: "/content/testimonials/1st Card.png",
    linkedin: "https://www.linkedin.com/in/dr-shailendra-aswale-99b5ba7/",
    color: '#FF4141',
  },
  {
    quote: "Aditya approaches every task with a thoughtful sense of urgency, great technical skills, attention to detail, and openness to instruction. I would hire him again without hesitation.",
    name: "Dr. Liz Wanless",
    designation: "Director of the Sport Innovation Institute - Indiana University",
    src: "/content/testimonials/2nd Card.jpeg",
    linkedin: "https://www.linkedin.com/in/wanless/",
    color: '#00629B',
  },
  {
    quote: "Aditya has always been a really good and empathic teammate in UX events that we have taken part in. He understands and knows what's required and is really good at doing UX research. He would be probably the best teammate to have in a group project. Moreover, there will always be a case where you'll get to learn something new from him since he's very well versed with what he does.",
    name: "Riya Kosta",
    designation: "Product Designer - Nexocide Pvt. Ltd.",
    src: "/content/testimonials/3rd Card.jpeg",
    linkedin: "https://www.linkedin.com/in/riyakosta/",
    color: '#00AE74',
  },
  {
    quote: "Aditya is a reliable and detail-oriented research assistant who contributed (and still contributing) strongly to literature review work in our lab. He consistently followed instructions, met deadlines, and demonstrated care and precision in his research tasks. Aditya shows clear potential for a research career, and I appreciated his professionalism and positive attitude throughout our collaboration. I look forward to involve him to more hands-on tasks with the participants as well.",
    name: "Dr. Ekaterina Muravevskaia",
    designation: "SETH Lab Advisor, Indiana University",
    src: "/content/testimonials/7th Card.jpeg",
    linkedin: "https://www.linkedin.com/in/ekaterinasavkina/",
    color: '#B31B1B',
  },
  {
    quote: "Aditya was one of the brightest and most motivated students in his class, consistently ranking in the top 1% of the program. He actively participated in and contributed to various technical and cultural college events by designing graphics for college websites and banners.",
    name: "Razia Sardinha",
    designation: "Training and Placement Officer - Padre Conceição College of Engineering",
    src: "/content/testimonials/4th Card.jpeg",
    linkedin: "https://www.linkedin.com/in/razia-de-loyola-furtado-e-sardinha-133384118/",
    color: '#E8A020',
  },
  {
    quote: "Aditya is creative, dedicated, and a true collaborator. He displays a strong sense of responsibility and accountability as a leader, handles feedback well, and adapts quickly to any given scenario. It is traits like these that made me comfortable to appoint him as one of the design leads. Needless to say, he lived up to the title and did a phenomenal job.",
    name: "Nadia Fernandes",
    designation: "Heston Community School. (Ex Professor - Padre Conceição College of Engineering)",
    src: "/content/testimonials/5th Card.jpeg",
    linkedin: "https://www.linkedin.com/in/nadia-fernandes-b3988b19b/",
    color: '#7C3AED',
  },
  {
    quote: "Aditya has always been amazing at his work. He is easy-going and was punctual with his work with DSC. It was great work with him.",
    name: "Shreya Sawant",
    designation: "Google Developer Student Clubs PCCE Lead",
    src: "/content/testimonials/6th Card.jpeg",
    linkedin: "https://www.linkedin.com/in/shreya-sawant-27868421a/",
    color: '#2E538D',
  },
];
